// A login form is only half a login: the guest still needs the Terms checkbox and the
// Connect button, and the guest page no longer adds them by itself — the page places a
// "Terms + Connect Button" (login-submit) block where it wants them. The backend refuses
// to publish a page in that state (backend/utils/landingPageSchema.js#loginSubmitMissing);
// this mirrors it so the builder can warn before the guest-facing error.
export const LOGIN_FORM_TYPES = [
    'pms-login', 'voucher-login', 'otp-login', 'resident-login', 'staff-login', 'login-methods',
];

function containsType(nodes, types) {
    return (nodes || []).some((node) => types.includes(node.type) || containsType(node.children, types));
}

export function loginSubmitMissing(nodes) {
    return containsType(nodes, LOGIN_FORM_TYPES) && !containsType(nodes, ['login-submit']);
}

export const LOGIN_SUBMIT_MISSING_MESSAGE =
    'This page has a login form but no "Terms + Connect Button" block, so guests could not log in. Add one where you want it.';
